import { Grid } from "@material-ui/core";
import { isEmpty } from "lodash";
import { naturalSort } from "../../../../../utils/naturalSort";
import ReactSelectCheckboxes from "../../../../Selects/ReactSelectCheckboxes";

export default function ClassificationFilters(props) {
  const {
    classifications = {},
    filters = {},
    handleFilterChange = () => null,
  } = props;

  const classificationFilters = Object.keys(classifications || {}).map(
    (k) => {
      const { name, classificationId, children } = classifications[k];

      if (!isEmpty(children)) {
        return (
          <Grid item xs={6} key={classificationId}>
            <label>{name}</label>
            <ReactSelectCheckboxes
              options={[
                ...Object.keys(children)
                  .map((childKey) => {
                    return {
                      label: children[childKey].name,
                      value: children[childKey].classificationId,
                      parentId: classificationId,
                    };
                  })
                  .sort((a, b) => naturalSort(a.label, b.label)),
              ]}
              onChange={(e) => {
                handleFilterChange({ [name]: e });
              }}
              value={filters[name]}
            />
          </Grid>
        );
      }
      return null;
    }
  );

  return <>{classificationFilters}</>;
}
